import type { ChatTurnResponse } from "../../api";

export interface ChatTurn {
  id: string;
  question: string;
  /** undefined while loading, null on error. */
  response: ChatTurnResponse | null | undefined;
  error?: string;
}

interface ChatExchangeProps {
  turn: ChatTurn;
  onDismiss: () => void;
}

/**
 * Floating chat-response panel anchored above the chat bar. Single-turn MVP —
 * multi-turn history + persistence land in Session 1c.
 */
export function ChatExchange({ turn, onDismiss }: ChatExchangeProps) {
  const loading = turn.response === undefined;
  return (
    <div className="chat-exchange">
      <span className="bracket tl" />
      <span className="bracket tr" />
      <span className="bracket bl" />
      <span className="bracket br" />

      <div className="chat-exchange-header">
        <div className="chat-exchange-title">
          <span className="panel-title-marker" />
          EDGE RESPONSE
        </div>
        <button className="chat-exchange-close" onClick={onDismiss} title="Dismiss">
          ×
        </button>
      </div>

      <div className="chat-exchange-body">
        <div className="chat-q">
          <span className="chat-q-prompt">›</span> {turn.question}
        </div>

        {loading && (
          <div className="chat-thinking">
            <span className="chat-thinking-dot" />
            <span className="chat-thinking-dot" />
            <span className="chat-thinking-dot" />
            <span className="chat-thinking-label">THINKING</span>
          </div>
        )}

        {turn.error && <div className="chat-error">⚠ {turn.error}</div>}

        {turn.response && (
          <>
            <div className="chat-a">{turn.response.text}</div>
            {turn.response.tool_calls.length > 0 && (
              <div className="chat-tool-trace">
                tools used:{" "}
                {turn.response.tool_calls.map((t, i) => (
                  <span key={i} className="chat-tool-name">
                    {t.name}
                  </span>
                ))}
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
}
